import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import useDepartmentSelector from "../../hooks/useDepartmentSelector";
import { useEffect, useState } from "react";

const getOwnerRegistrationData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const [usersData, setUsersData] = useState({});

  if (id) {
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearchFormLandUse(tenantId, { applicationNo: id });
    };

    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
    const applicationData = isSuccess && data?.LandUse?.[0];
    return { applicationData, isAppDataLoading };
  }

  const { info: userInfo } = Digit.UserService.getUser();
  const userUid = userInfo?.uuid;
  const applicationType = "FORM_OWNER_REGISTRATION";
  const { documents } = useSelector((state) => state.formMT);

  async function searchUser() {
    try {
      const response = await Digit.UserService.userSearch(tenantId, { uuid: [userUid] }, {});
      console.log("searchUser:", response);
      setUsersData(response);
      return response;
    } catch (error) {
      console.error("Error during user search:", error);
    }
  }
  useEffect(() => {
    searchUser();
  }, []);
  const registrationArchitectNumber = usersData?.user?.[0]?.registrationArchitectNumber;

  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo?.name,
      mobileNumber: userInfo?.mobileNumber,
      emailId: userInfo?.emailId,
      address: {
        address: userInfo?.permanentAddress,
        district: null,
        state: null,
      },
      registrationNumber: userInfo?.registrationNumber,
      registrationArchitectNumber: registrationArchitectNumber,
    },
    descriptionOfLand: {
    },
    checklist: {
      allotmentDate: null,
      isPossesionAreaDiff: null,
      areaOfExtraLand: null,
      paymentStatus: null,
      agreementDate: null,
      uptodatePaymentStatus: null,
      registryStatus: null
    },
    applicationType,
    approvedLayout: null,
    feeType: "ApplicationFee",
    department: applicationFlow,
    workflow: { action: "INITIATE", assignes: [userUid] },
    landInfo: {
      tenantId,
      address:{
        tenantId,
        locality: {
          code: "Lucknow"
        }
      },
      bankdetails: {
        accountHolderName: null,
        branchName: null,
        ifscCode: null, 
        accountNo: null,
        bankName: null,
      }
    },
    businessService: "BPA_OWNER_REGISTRATION",
    documents,
    uiFlow: { flow: "FORM_OWNER_REGISTRATION" },
  };

  return { applicationData, isAppDataLoading: false };
};

export default getOwnerRegistrationData;
